import { FormControlLabel, Grid2, Radio, RadioGroup } from "@mui/material";
import styles from "./ExplorePlansStyle.module.scss";
import { CancelOutlined } from "@mui/icons-material";

export default function ExplorePlans({
  licenseInfo,
  planImages,
  planType,
  setPlanType,
  toggleType,
  // setToggleType,
  country,
  newPlan,
  setNewPlan,
  onPlanSelect,
  onCancel,
  userDetails,
  hostingType,
  setHostingType,
}) {
  // const handleToggleChange = () => {
  //   setToggleType((prevType) =>
  //     prevType === "monthly" ? "yearly" : "monthly"
  //   );
  // };

  const handlePlanClick = (plan) => {
    setNewPlan(plan);
    const selectedPricing = plan.pricing[toggleType];
    const price =
      country === "India"
        ? selectedPricing.priceInINR
        : selectedPricing.priceInUSD;
    onPlanSelect(toggleType, price, selectedPricing.priceId);
  };

  const filteredLicenseInfo = licenseInfo
    ?.filter((license) => license.licenseType !== "To The Moon")
    ?.sort((a, b) => {
      const order = ["LaunchPad", "GrowthGear", "Momentum", "Booster"];
      return order.indexOf(a.licenseType) - order.indexOf(b.licenseType);
    });

  const mappedPlans = filteredLicenseInfo?.map((license) => {
    const features = license.features?.reduce((acc, feature) => {
      acc[feature.type] = feature.limitOrAvailablity;
      return acc;
    }, {});

    const pricing = license.pricing?.reduce((acc, price) => {
      acc[price.billingType.toLowerCase()] = {
        priceInUSD: price.originalprice,
        priceInINR: price.orginalPrice_INR,
        priceId: price.stripePriceId,
        salePriceInr: price.salePriceInr,
      };
      return acc;
    }, {});
    return {
      planName: license.licenseType,
      planImage: planImages[license.licenseType] || null,
      numSites: features.NUM_SITES || "N/A",
      visits: features.VISITS || "N/A",
      storage: features.STORAGE ? `${features.STORAGE} GB` : "N/A",
      bindwidth: features.BANDWIDTH ? `${features.BANDWIDTH} GB` : "N/A",
      pricing: pricing,
      singleSitePlan: license.isSingleSitePlan,
      planId: license.planId,
    };
  });

  const filteredPlans = mappedPlans?.filter((plan) => {
    if (planType === "solo") return plan.singleSitePlan === true;
    if (planType === "multi") return plan.singleSitePlan === false;
    return true;
  });

  return (
    <Grid2 className={styles.mainContainer}>
      <Grid2 className={styles.toggleContainer}>
        <Grid2 className={styles.hostingTypeContainer}>
          <Grid2 className={styles.hostingButton}>
            <Grid2
              className={`${
                hostingType === "kubernetes"
                  ? styles.activeHosting
                  : styles.inActiveHosting
              } ${hostingType === "kubernetes" ? styles.leftActive : ""}`}
              style={{ left: hostingType === "kubernetes" ? 0 : "50%" }}
              onClick={() => setHostingType("kubernetes")}
            >
              Kubernetes Hosting
            </Grid2>
            <Grid2
              className={`${
                hostingType === "dedicated"
                  ? styles.activeHosting
                  : styles.inActiveHosting
              } ${hostingType === "dedicated" ? styles.rightActive : ""}`}
              style={{ left: hostingType === "dedicated" ? 0 : "-50%" }}
              onClick={() => setHostingType("dedicated")}
            >
              Dedicated Hosting
            </Grid2>
          </Grid2>
        </Grid2>
        <Grid2 className={styles.cancel} onClick={onCancel}>
          <CancelOutlined className={styles.cancelIcon} />
        </Grid2>
      </Grid2>
      {/* <Grid2 className={styles.durationToggleContainer}>
        <Grid2>Monthly</Grid2>
        <Grid2 className={styles.durationToggle} onClick={handleToggleChange}>
          <Grid2 className={styles.toggleOnOff}>
            <Grid2
              className={`${styles.monthlyLabel} ${
                toggleType === "monthly" ? styles.active : ""
              }`}
            />
            <Grid2
              className={`${
                toggleType === "monthly" ? styles.month : styles.year
              }`}
            />
            <Grid2
              className={`${styles.yearlyLabel} ${
                toggleType === "yearly" ? styles.active : ""
              }`}
            />
          </Grid2>
        </Grid2>
        <Grid2 container>
          <Grid2>Yearly</Grid2>
        </Grid2>
      </Grid2> */}

      <Grid2 className={styles.containerRename}>
        <RadioGroup
          row
          value={planType}
          onChange={(e) => setPlanType(e.target.value)}
        >
          <FormControlLabel
            value="multi"
            control={<Radio className={styles.radioButton} />}
            label="Multi-Site Plans"
            className={`${planType === "multi" ? styles.selected : ""}`}
            style={{
              color: planType === "multi" ? "#135fc2" : "inherit",
              cursor: "pointer",
            }}
            sx={{
              "& .MuiFormControlLabel-label": {
                fontSize: "14px",
                fontWeight: "500",
                color:
                  planType === "multi"
                    ? "#135fc2"
                    : userDetails?.theme === "dark"
                      ? "#ffffff"
                      : "#000000",
              },
              "& .MuiRadio-root": {
                color:
                  planType === "multi"
                    ? "#135fc2"
                    : userDetails?.theme === "dark"
                      ? "#ffffff"
                      : "#000000",
              },
            }}
          />
          <FormControlLabel
            value="solo"
            control={<Radio className={styles.radioButton} />}
            label="Solo-Site Plans"
            className={`${planType === "solo" ? styles.selected : ""}`}
            style={{
              color: planType === "solo" ? "#135fc2" : "inherit",
              cursor: "pointer",
            }}
            sx={{
              "& .MuiFormControlLabel-label": {
                fontSize: "14px",
                fontWeight: "500",
                color:
                  planType === "solo"
                    ? "#135fc2"
                    : userDetails?.theme === "dark"
                      ? "#ffffff"
                      : "#000000",
              },
              "& .MuiRadio-root": {
                color:
                  planType === "solo"
                    ? "#135fc2"
                    : userDetails?.theme === "dark"
                      ? "#ffffff"
                      : "#000000",
              },
            }}
          />
        </RadioGroup>
      </Grid2>

      <Grid2 className={styles.planContainer}>
        <Grid2 className={styles.sitesBox}>
          <Grid2 className={styles.sites}>No.Of SITES</Grid2>
          <Grid2 className={styles.sites}>VISITS</Grid2>
          <Grid2 className={styles.sites}>STORAGE</Grid2>
          <Grid2 className={styles.sites}>BANDWIDTH</Grid2>
        </Grid2>

        <Grid2 className={styles.CardContainer}>
          {filteredPlans?.map((plan, index) => (
            <Grid2
              item
              key={index}
              className={`${
                newPlan?.planId === plan.planId
                  ? styles.selected
                  : styles.planCard
              }`}
              onClick={() => {
                if (newPlan?.planId !== plan.planId) {
                  handlePlanClick(plan);
                }
              }}
            >
              <Grid2 className={styles.imagePlan}>
                <Grid2>{plan.planImage}</Grid2>
                <Grid2 className={styles.planName}>{plan.planName}</Grid2>
              </Grid2>
              {/* <Grid2 className={styles.price}>
                <Grid2 className={styles.price}>
                  {toggleType === "monthly" ? (
                    <>
                      {country === "USA" ? (
                        <div>{`$${plan.pricing.monthly.priceInUSD}/M`}</div>
                      ) : (
                        <div>{`₹${plan.pricing.monthly.salePriceInr}/M`}</div>
                      )}
                    </>
                  ) : (
                    <>
                      {country === "USA" ? (
                        <div>{`$${plan.pricing.yearly.priceInUSD}/Yr`}</div>
                      ) : (
                        <div>{`₹${plan.pricing.yearly.salePriceInr}/Yr`}</div>
                      )}
                    </>
                  )}
                </Grid2>
              </Grid2> */}
              <Grid2 className={styles.numSites}>{plan.numSites}</Grid2>
              <Grid2 className={styles.numSites}>{plan.visits}</Grid2>
              <Grid2 className={styles.numSites}>{plan.storage}</Grid2>
              <Grid2 className={styles.numSites}>{plan.bindwidth}</Grid2>
            </Grid2>
          ))}
        </Grid2>
      </Grid2>
    </Grid2>
  );
}
